(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodMouseoverItem', sodMouseoverItem);

    function sodMouseoverItem() {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                eventName: '=',
                eventData: '=?',
                label: '=?',
                type: '@?',
            },
            template: '<div class="sod-mouseover-item"><ng-transclude></ng-transclude><div ng-class="type"><span sod-emit-event event-name="eventName" event-data="eventData" label="label"></span></div></div>',
            link: function(scope, elem) {
                if (!scope.type) {
                    scope.type = 'default';
                }

            }
        };
    }

})();